import React from "react";
import clsx from "clsx";

type ChipVariant = "default" | "subtle" | "dark";

interface ChipProps {
    children: React.ReactNode;
    variant?: ChipVariant;
    className?: string;
}

export default function Chip({ children, variant = "default", className }: ChipProps) {
    const variants: Record<ChipVariant, string> = {
        default: "bg-bg-page border border-border-subtle text-text-secondary",
        subtle: "bg-bg-subtle text-text-muted",
        dark: "bg-black text-white"
    };

    return (
        <span
            className={clsx(
                "inline-flex items-center rounded-full px-3 py-1 text-sm font-medium w-fit",
                variants[variant],
                className
            )}
        >
            {children}
        </span>
    );
}
